<template>
  <a-card :bordered="false">
    <search-page-view
      ref="pageList"
      rowKey="touristContractId"
      :itemNames="['name_1','name_2','name_3']"
      :columns="getColumns()"
      :col="4"
      :queryParams="queryParams"
      :requestPromise="getListPromise"
    >
      <a-form-item slot="name_1" label="合同编号" v-bind="searchItemLayout">
        <a-input v-model="queryParams.contractCode" placeholder="请输入"/>
      </a-form-item>
      <a-form-item slot="name_2" label="订单编号" v-bind="searchItemLayout">
        <a-input v-model="queryParams.orderCode" placeholder="请输入"/>
      </a-form-item>
      <a-form-item slot="name_3" label="合同状态" v-bind="searchItemLayout">
        <a-select
          style="width: 100%"
          v-model="queryParams.contractSignStatus"
          placeholder="请选择" allowClear
        >
          <a-select-option v-for="(item,index) in contractSignStatusList" :key="index" :value="item.key">{{
              item.value
            }}
          </a-select-option>
        </a-select>
      </a-form-item>
      <span slot="orderCodes" slot-scope="rowItem">
        <a-tooltip placement="topLeft">
          <template slot="title">
            {{ rowItem.record.orderCodes.join() }}
          </template>
          <div class="pro_title">
            {{ rowItem.record.orderCodes.join() }}
          </div>
        </a-tooltip>
      </span>
      <span slot="contractCost" slot-scope="rowItem">
        ￥{{ rowItem.record.contractCost }}
      </span>
      <span slot="action" slot-scope="rowItem">
        <a @click="toDetail(rowItem.record)">详情</a>
      </span>
    </search-page-view>
  </a-card>
</template>

<script>
export default {
  name: 'ElectronicContractList',
  data() {
    return {
      queryParams: {
        merchantId: this.$store.getters.userInfo.merchantId,
        platformId: this.getPlatformConfig().platformId
      },
      serverUniqueId: this.$route.query.serverUniqueId,
      serverId: this.$route.query.serverId,
      searchItemLayout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 16 }
      },
      contractSignStatusList: []
    }
  },
  created() {
    this.getContractSignStatusEnum()
  },
  methods: {
    getContractSignStatusEnum() {
      this.getHttpServices().getServerApiService().post('tourist/contract/getContractSignStatusEnum').then(res => {
        this.contractSignStatusList = res
      }).catch(reason => this.showNetWorkErrorMessage(reason))
    },
    getListPromise(params) {
      return this.getHttpServices().getServerApiService().post('tourist/contract/list', params)
    },
    getColumns() {
      return [
        {
          title: 'ID',
          dataIndex: 'touristContractId'
        },
        {
          title: '合同类型',
          dataIndex: 'templateTypeStr'
        },
        {
          title: '合同编号',
          dataIndex: 'contractCode'
        },
        {
          title: '订单号',
          dataIndex: 'orderCodes',
          scopedSlots: { customRender: 'orderCodes' },
          width: '25%'
        },
        {
          title: '合同金额',
          dataIndex: 'contractCost',
          scopedSlots: { customRender: 'contractCost' }
        },
        {
          title: '创建时间',
          dataIndex: 'createTime'
        },
        {
          title: '签署时间',
          dataIndex: 'signTime'
        },
        {
          title: '合同状态',
          dataIndex: 'contractSignStatusStr'
        },
        {
          title: '操作',
          dataIndex: 'action',
          align: 'center',
          scopedSlots: { customRender: 'action' },
          fixed: 'right'
        }
      ]
    },
    toDetail(record) {
      let selectedRowKeys = record.orderCodes
      this.openNewPage('ElectronicContractDetail', {
        serverId: this.serverId,
        serverUniqueId: this.serverUniqueId,
        orderNoList: JSON.stringify(selectedRowKeys),
        proCatalog: this.proCatalog,
        type: '2',
        contractSignStatus: record.contractSignStatus,
        touristContractId: record.touristContractId
      })
    }
  }
}
</script>

<style lang="less" scoped>
.pro_title {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  -ms-text-overflow: ellipsis;
  text-overflow: ellipsis;
}
</style>

